import { useRefillsStore } from '../../../stores/useRefillsStore';

export interface RefillsFooterProps {
  onReviewOrder: () => void;
}

export function RefillsFooter({ onReviewOrder }: RefillsFooterProps) {
  const { selectedRefills, loading, noScripts } = useRefillsStore();

  if (loading || noScripts) return null;

  const hasSelected = selectedRefills.length > 0;
  // Review Order is enabled once at least one Rx is selected. A missing shipping
  // address for home delivery is NOT gated here by disabling the button — instead
  // clicking surfaces a transient validation toast (see RefillsPage.handleReviewOrder),
  // matching production behavior (legacy alertify.error, refillController.js:517) that
  // UAT VSDP-5997 asked us to restore.
  const disabled = !hasSelected;

  return (
    <div className="panel-footer refill-list-footer">
      <div className="row confirm-container" style={{ paddingRight: 10 }}>
        <button
          type="button"
          disabled={disabled}
          className={`btn btn-success pull-right review-order-btn${hasSelected ? ' review-selected' : ''}`}
          onClick={onReviewOrder}
        >
          Review Order
        </button>
      </div>
    </div>
  );
}
